module.exports = __webpack_public_path__ + "img/Numerai-Logo-Side-White.03e7575d.png";